import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import AboutUs from '@/components/AboutUs'

import Invest from '@/components/Invest'
import Plan from '@/components/Plan'
import Analysis from '@/components/Analysis'
import Train from '@/components/Train'
import Layout from '@/components/Layout'
import Capital from '@/components/Capital'

import Service from '@/components/Service'
import News from '@/components/News'
import NewsDetail from '@/components/NewsDetail'
import ContactUs from '@/components/ContactUs'

import Privacy from '@/components/Privacy'

Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/invest',
      name: 'Invest',
      component: Invest
    },
    {
      path: '/plan',
      name: 'Plan',
      component: Plan
    },
    {
      path: '/analysis',
      name: 'Analysis',
      component: Analysis
    },
    {
      path: '/train',
      name: 'Train',
      component: Train
    },
    {
      path: '/layout',
      name: 'Layout',
      component: Layout
    },
    {
      path: '/capital',
      name: 'Capital',
      component: Capital
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/newsdetail',
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/contactus',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js